<template>
  <dd v-text="treesCount" />
</template>

<script>
import { useTotalDonations } from '../composables/useTotalDonations';

export default {
  name: 'PlantedTreesInfo',

  setup() {
    const {
      totalDonations,
      hasDonations,
      hasSingleDonations,
      hasRecurringDonations,
      treesCount,
    } = useTotalDonations();
    return {
      totalDonations,
      hasDonations,
      hasSingleDonations,
      hasRecurringDonations,
      treesCount,
    };
  },
};
</script>
